import { FirebaseError } from 'firebase/app';

export function ignoreError(error: string | Error): boolean {
  if (error instanceof FirebaseError) {
    return error.code === 'auth/network-request-failed';
  }

  return false;
}
